import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { WPService } from 'src/app/core/http/web/wp.service';
import { environment as params } from 'src/environments/environment';

@Component({
  selector: 'app-posicionamiento',
  templateUrl: './posicionamiento.component.html',
  styleUrls: ['./posicionamiento.component.scss']
})
export class PosicionamientoComponent implements OnInit {
  urlBaseS3: any = (<any>params).api.s3;
  public errors: any = null;
  public loadings: any = true;
  public objectValues = Object.values;
  public positionData: any;
  public cardsData: any;
  @Input('route') public route: string;
  @Input('load_serv') public load_serv: boolean = true;
  @Input('data') public data: any = null;

  constructor(
    private _homeService: HomeService,
    private wpServ: WPService
  ) {
  }

  ngOnInit() {
    this.positionData = this.data.posicionamiento;
    this.cardsData = this.data.methodpayment;
    if (this.load_serv) {
      this.getPosition();
    }
    console.log('Datos en posicionamiento: ', this.data);
  }

  getPosition() {
    this._homeService.getPosition(this.route).subscribe(data => {
      // console.log("Subscribe", data);
      this.positionData = data.posicionamiento;
      if (!(data.posicionamiento)) {
        console.warn('Sin posicionamiento para mostrar');
        this.loadings = false;
      }
    }, err => {
      console.error(err);
      this.errors = err;
    });
  }

  reload() {
    this.loadings = true;
    this.getPosition();
  }

}
